export default "__VITE_ASSET__CeCl05yF__"